import L from 'leaflet';
import { FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';

const CreateGroup = ({ onChange }) => {
    const _onCreated = e => {
        let layer = e.layer;
        const createFeature = layer.toGeoJSON();
        onChange({ type: 'FeatureCollection', features: [createFeature] });
    };

    return (
        <FeatureGroup>
            <EditControl
                position="topright"
                onCreated={_onCreated}
                draw={{
                    polyline: {
                        icon: new L.DivIcon({
                            iconSize: new L.Point(8, 8),
                            className: 'leaflet-div-icon leaflet-editing-icon',
                        }),
                        shapeOptions: {
                            guidelineDistance: 10,
                            color: 'navy',
                            weight: 3,
                        },
                    },
                    marker: false,
                    rectangle: false,
                    circlemarker: false,
                    circle: false,
                    polygon: false,
                }}
            />
        </FeatureGroup>
    );
};

export default CreateGroup;
